// extracted by mini-css-extract-plugin
export default {"header":"styles_header__qPlfY","title_container":"styles_title_container__3iKJB","title_icon_container":"styles_title_icon_container__jpj8q","title_icon":"styles_title_icon__ky9jV"};